export default "/assets/images/app-update-img-01.png?f35beed1c095cfd54daec5c531df3199";